import {parseOptions, useLazyGetAssetsRelatedOptionsForInfiniteScrollingQuery} from '../../../../redux/api/assets';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {OptionLabelValue} from '../../../../types/internal/OptionLabelValue';
import {useDispatch, useSelector} from 'react-redux';
import {addFilters, removeFilters, selectAssets, selectAssetsTableFilters} from '../../../../redux/slices/assets';
import {capitalize} from 'lodash';
import {useTranslation} from 'react-i18next';
import {AssetsFiltersFE, fromFeToBeAssetsFilters} from '../../../../types/internal/tables/assetsTable';
import {selectMapFilters} from '../../../../redux/slices/mapFilters';
import NEWListWithSearchFilter from '../../../common/filters/NEWListWithSearchFilter';
import {useGetHazardTypeClassesQuery} from "../../../../redux/api/hazardTypes";

export default function HazardFilter({column}: { column: string }) {

  const {
    data: hazardTypes,
  } = useGetHazardTypeClassesQuery();
  const [getData, {
    data,
    isLoading,
    isFetching,
    isUninitialized,
    originalArgs,
  }] = useLazyGetAssetsRelatedOptionsForInfiniteScrollingQuery();
  const [querySearch, setQuerySearch] = useState<string>('');
  const options: OptionLabelValue[] = useMemo(() => parseOptions(data?.results || []), [data?.results]);
  const total = data?.count || 0;
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const placeholder = capitalize(t('table.filterPlaceholder', {column: hazardTypes?.find(ht => ht.code === column)?.name ?? ""}));

  const assetsTableFiltersWithoutCurrentHazardRef = useRef<AssetsFiltersFE>({});
  const assetsTableFilters = useSelector(selectAssetsTableFilters);
  const polygonFilter = useSelector(selectMapFilters).polygons;
  const selectedFilters: OptionLabelValue[] = assetsTableFilters?.hazards?.[column] || [];
  const filtersInExcludeMode = useSelector(selectAssets).assetsTable.filtersInExcludeMode;

  useEffect(() => {
    const {hazards, ...otherFilters} = assetsTableFilters;
    const {[column]: _currentHazard, ...otherHazards} = hazards || {};
    assetsTableFiltersWithoutCurrentHazardRef.current = {
      ...otherFilters,
      ...(Object.keys(otherHazards).length > 0 && {hazards: otherHazards}),
    };
  }, [assetsTableFilters, column]);

  const handleGetNext = useCallback(() => {
    getData({
      column,
      ...!!querySearch && {column_search: querySearch},
      ...fromFeToBeAssetsFilters(assetsTableFiltersWithoutCurrentHazardRef.current, filtersInExcludeMode),
      ...!!polygonFilter?.length && {polygon_uuid: polygonFilter.map(polygon => polygon.globalpolygon).join(',')},
      page: (originalArgs?.page || 0) + 1,
      page_size: 15,
    });
  }, [column, filtersInExcludeMode, getData, originalArgs?.page, polygonFilter, querySearch]);

  useEffect(() => {
    getData({
      column,
      ...!!querySearch && {column_search: querySearch},
      ...fromFeToBeAssetsFilters(assetsTableFiltersWithoutCurrentHazardRef.current, filtersInExcludeMode),
      ...!!polygonFilter?.length && {polygon_uuid: polygonFilter.map(polygon => polygon.globalpolygon).join(',')},
      page: 1,
      page_size: 15,
    });
  }, [column, filtersInExcludeMode, getData, polygonFilter, querySearch]);

  return <>
    <NEWListWithSearchFilter
      getNext={handleGetNext}
      options={options}
      selectedOptions={selectedFilters}
      setSelectedOptions={values => {
        if (values.length) {
          dispatch(addFilters({hazards: {[column]: values}}));
        } else {
          dispatch(removeFilters(column));
        }
      }}
      total={total}
      isLoadingOptions={isLoading || isFetching || isUninitialized}
      querySearch={querySearch}
      setQuerySearch={setQuerySearch}
      search={{placeholder}}
    />
  </>;
}
